import { useMemo, useCallback } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import type { Permission } from '@/types/rbac-auth.types';

/**
 * Refleja la sesión RBAC. hasPermission chequea permisos REALES del /me/profile
 * (antes estaba desactivado: devolvía true para todo).
 */
export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const permissions = useAuthStore((s) => s.permissions);
  const roleAssignments = useAuthStore((s) => s.roleAssignments);
  const status = useAuthStore((s) => s.status);

  const permSet = useMemo(() => new Set<string>(permissions), [permissions]);
  const hasPermission = useCallback((p: Permission) => permSet.has(p), [permSet]);

  return {
    user, roleAssignments, status,
    isAuthenticated: status === 'authenticated' && user !== null,
    hasPermission,
  };
}
